module.exports = __webpack_public_path__ + "img/vue.040442a0.png";